import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderCancelAutorenewMailSubsDialog = (data) => openPopupHelper({ popupName: popupNames.CANCEL_MAIL_SUBSCRIPTION, data });
